export default __webpack_public_path__ + "static/media/bobikeexterior.a81fdcb1.png";